import { ContextStore, ExperimentStore, PageStore } from "bernie-core";

import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

// Holds all the current experiments running in Blossom. Update and clean this as needed.
export enum Experiment {
  LOB_intent_search_button_text_hotels_pwa = "LOB_intent_search_button_text_hotels_pwa",
  Flex_Blossom_Qualtrics = "Flex_Blossom_Qualtrics",
  PWA_ESS_Feedback_Loop_Enable = "PWA_ESS_Feedback_Loop_Enable",
  Typeahead_Enabling_Google_Autocomplete_Suggestion_for_Car_Lob = "Typeahead_Enabling_Google_Autocomplete_Suggestion_for_Car_Lob",
  Flex_HTG_Blossom_POSa_Redirect_Banner = "Flex_HTG_Blossom_POSa_Redirect_Banner",
  Flex_typeahead_in_wizard = "Flex_typeahead_in_wizard",
  Add_Distance_to_Nearest_Points_on_Hotel_cards = "Add_Distance_to_Nearest_Points_on_Hotel_cards",
  Flex_HFTG_Affinity_Reviews = "Flex_HFTG_Affinity_Reviews",
  Blossom_SRP_Lite_V2 = "Blossom_SRP_Lite_V2",
  MIT_PWASF_PKGFLEXIBILITY_FSSSE = "MIT_PWASF_PKGFLEXIBILITY_FSSSE",
  Blossom_Skip_Server_Fetch = "Blossom_Skip_Server_Fetch",
  Feature_Gate_MAB_on_SF = "Feature_Gate_MAB_on_SF",
  LP_SC_Covid19_TravelAdvisory_for_LandingPages = "LP_SC_Covid19_TravelAdvisory_for_LandingPages",
  LP_WIZARD_POPULAR_FILTERS_ON_HTG = "LP_WIZARD_POPULAR_FILTERS_ON_HTG",
  Chatbot_FAB_for_PWA = "Chatbot_FAB_for_PWA",
  VAC_PhaseOne = "VAC_PhaseOne",
  VAC_PhaseTwo = "VAC_PhaseTwo",
  VAC_PhaseThree = "VAC_PhaseThree",
  New_Package_Flight_Type_Multicity = "MIT_PWA_PKGFLEXIBILITY_MCITYPKG", // 35877
  New_Package_Flight_Type_Oneway = "MIT_PWA_PKGFLEXIBILITY_ONEWAYPKG", // 35880
  Flex_Enable_Graphql_Modules = "Flex_Enable_Graphql_Modules",
  Surface_PWA_SF_Travel_Advisory_Chatbot = "Surface_PWA_SF_Travel_Advisory_Chatbot",
  Package_HC_Different_Pickup_Location = "MIT_PWA_FLEXIBLE_HC", // 37221
  Flex_Blossom_Wizard_Redesign = "Flex_Blossom_Wizard_Redesign", // 37405,
  Blossom_Mab_Wizard_Search_Button_Copy = "Blossom_Mab_Wizard_Search_Button_Copy", // 37516
  TNL_for_blossom_launch_for_TVLY = "TNL_for_blossom_launch_for_TVLY", //37891
  TNL_for_blossom_launch_for_Orbitz = "TNL_for_blossom_launch_for_Orbitz", //37890
  Flex_blossom_landing_page_chatbot = "Flex_blossom_landing_page_chatbot", // 38171
  Alignment_of_Traveler_Input = "Alignment_of_Traveler_Input", // 38265
  posa_switcher_sf_rollout = "posa_switcher_sf_rollout", // 38460
  Destination_Pricing_Rate_Calendar_HTG_Filter_Wizard = "Destination_Pricing_Rate_Calendar_HTG_Filter_Wizard", // 39068
  PWA_PACKAGE_WIZARD_3PP_DEFAULT_TAB = "PWA_PACKAGE_WIZARD_3PP_DEFAULT_TAB", //39172
  PWA_Package_Wizard_Type_Menu_Checkboxes = "PWA_Package_Wizard_Type_Menu_Checkboxes", //39446
  SDUI_Trips_Total_Throttle = "SDUI_Trips_Total_Throttle", //39455
  PWA_Trips_Important_SF = "PWA_Trips_Important_SF", //39599
  LS_Prefetch_JavaScript_Bundles = "LS_Prefetch_JavaScript_Bundles", // 39679
  Trips_PWA_SDUI_Rollout = "Trips_PWA_SDUI_Rollout", //39594
  FAQ_LeadPrice_on_PDP_Traffic_Test = "FAQ_LeadPrice_on_PDP_Traffic_Test", // 37486,
  Trip_Hero_Web = "Trip_Hero_Web", // 40744
  LP_Immediate_Property_Filtering = "LP_Immediate_Property_Filtering", // 40648
  MeSo_Lazy_Loading_BEXG_NA = "MeSo_Lazy_Loading_BEXG_NA", // 40926
  Blossom_Node_Streaming = "Blossom_Node_Streaming", // 40960
  Blossom_Dynamic_Render = "Blossom_Dynamic_Render", // 41029
  Cars_Lift30DaysRestrictionOnEMEA = "Cars_Lift30DaysRestrictionOnEMEA", // 41243
  MeSo_Single_Card_Marquee = "MeSo_Single_Card_Marquee", // 41320
  MeSo_Single_Card_Feature_Flag = "MeSo_Single_Card_Feature_Flag", // 41348
  EXPEDIA_BRAND_REFRESH = "EXPEDIA_BRAND_REFRESH",
  ADF21 = "ADF21", // 41547,
  EXPEDIA_BRAND_REFRESH_JUNE = "EXPEDIA_BRAND_REFRESH_JUNE", // 41563,
  Transportation_North_Star = "Transportation_North_Star", // 41631,
  TTD21 = "TTD21", // 41692
  BEX_Driveable_destination_Web = "BEX_Driveable_destination_Web", //41955
  BEX_Homepage_Tabs_Test = "BEX_Homepage_Tabs_Test",
}

/**
 * Return bucket number of experiment.
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @returns {number} - Experiment Bucket
 */

export const getExperimentBucket = (context: ExtendedContextStore | undefined, experimentName: Experiment): number =>
  context?.experimentContext?.experiments?.[experimentName] || 0;

/**
 * Return bucket number of experiment from bernie experiments store.
 * @param {ExperimentStore} experiments - Instance of bernie experiment store
 * @param {string} experimentName - Experiment name used (check out link)
 * @returns {number} - Experiment Bucket
 */

export const getExperimentBucketFromExperimentsStore = (
  experiments: ExperimentStore | undefined,
  experimentName: Experiment
): number => experiments?.exposures?.[experimentName]?.bucket || 0;

/**
 * Checks if an experiment is in a given variant.
 * {@link https://tnl.prod.expedia.com}
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @param {number} value - Defaults to 1. Value that we are checking the experiment against
 * @returns {boolean} - True when the context contains an experiment string that matches a given numeric value
 */
export const isVariantEnabled = (
  context: ExtendedContextStore | undefined,
  experimentName: Experiment,
  value = 1
): boolean => getExperimentBucket(context, experimentName) === value;

/**
 * isVariantEnabledAndLog
 *
 * Checks whether an experiment is in a given bucket and logs the experiment.
 *
 * @param {string} experimentName Experiment name (programmatic, not friendly name)
 * @param {ContextStore} context ContextStore (Bernie), or ExtendedContextStore (Flex).
 * @param {ExperimentStore} experiment ExperimentStore (Bernie)
 * @param {PageStore} page PageStore (Bernie)
 * @param {number} bucket Value that we are checking the experiment against. Defaults to 1.
 *
 * @returns {boolean}
 */
export const isVariantEnabledAndLog = (
  experimentName: Experiment | string,
  context: ContextStore,
  experiment: ExperimentStore,
  page: PageStore,
  bucket = 1
): boolean => {
  const exposure = experiment.exposures?.[experimentName];

  if (!exposure) {
    return false;
  }

  experiment.logExperiment(context, page, exposure);

  return exposure.bucket === bucket;
};
